import {AfterViewInit, Component} from '@angular/core';
import {ContainerComponent} from '../../container/container.component';
import {NgOptimizedImage} from '@angular/common';
import {GtmEventsService} from '../../../shared/gtm-events.service';

@Component({
  selector: 'app-app-info',
  imports: [ContainerComponent, NgOptimizedImage],
  standalone: true,
  templateUrl: './app-info.component.html',
  styleUrl: './app-info.component.scss'
})
export class AppInfoComponent implements AfterViewInit {
  constructor(private _gtmEventsService: GtmEventsService) {
  }

  ngAfterViewInit(): void {
    this._gtmEventsService.pushPageView('Download de app');
  }
}
